module.exports = __webpack_public_path__ + "assets/img/14_899.45d0e3af.jpg";